import { render, staticRenderFns } from "./PaymentInfoSection.vue?vue&type=template&id=28a1a32c&scoped=true"
import script from "./PaymentInfoSection.vue?vue&type=script&lang=js"
export * from "./PaymentInfoSection.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoSection.vue?vue&type=style&index=0&id=28a1a32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1a32c",
  null
  
)

export default component.exports